import {call, put, delay} from "redux-saga/effects";
import axios from "axios";
import {LOGIN_OR_REGISTER_POST, LOGIN_STAFF, USERS_ACTIVATION_POST, RESEND_ACTIVATION_COD_POST} from "../../apis";
import qs from "querystring";
import * as actions from "../actions/user";
import {toast} from "react-toastify";
import {actionChangeDataFormLoginStaff} from "../actions/user";

export function* loginUserSaga({payload: {mobile, introduced_code, history}}) {
    yield put(actions.actionChangeLoaderBtnFormSendPhone(true));
    try {
        const response = yield call(axios.post, LOGIN_OR_REGISTER_POST, qs.stringify({mobile, introduced_code}));
        const {status, timer_time} = response.data;
        if (status === 'ok') {
            toast.success(`کد فعال سازی با موفقیت به شماره موبایل ${mobile} ارسال شد . `);
            history.push({
                pathname: '/auth/otp-validation',
                state: {from: history.location.state ? history.location.state.from : null}
            });
            yield put(actions.setTimerLoginUserSaga(parseInt(timer_time)));
        } else {
            toast.error(response.data.message);
        }

    } catch (e) {
        console.log(e);
        toast.error('لطفا مجددا تلاش کنید.');
    } finally {
        yield put(actions.actionChangeLoaderBtnFormSendPhone(false));
    }
}

export function* startTimerSaga({payload: {timer}}) {
    if (timer > 0) {
        yield delay(1000);
        yield put(actions.setTimerLoginUserSaga(timer - 1));
    }
}

export function* activeUserSaga({payload: {code}}) {
    yield put(actions.actionChangeLoaderBtnFormSendCodeValidation(true));
    try {
        const {appVersion, plugins, appCodeName, languages, innerWidth, platform, innerHeight} = navigator;
        const formData = qs.stringify({
            code, app_version: appVersion, app_code_name: appCodeName, languages: languages,
            platform: platform, plugins: plugins, width: innerWidth, height: innerHeight
        });
        const response = yield call(axios.post, USERS_ACTIVATION_POST, formData);

        const {status, info, token, message} = response.data;

        if (status === 'ok') {
            yield put(actions.actionChangeProfileUser(info));
            yield put(actions.actionChangeTokenUser(token));

            toast.success('با موفقیت به حساب کاربری خود وارد شدید.');
        } else if (status === 'error') {
            toast.error(message);
        }
    } catch (e) {
        console.log(e);
        toast.error('لطفا مجددا تلاش کنید.');
    } finally {
        yield put(actions.actionChangeLoaderBtnFormSendCodeValidation(false));
    }

}

export function* resendCodeSaga({payload: {mobile}}) {
    yield  put(actions.actionChangeDataFormSendCodeValidation('loaderBtnSendCode', true));
    try {
        const response = yield call(axios.post, RESEND_ACTIVATION_COD_POST, qs.stringify({mobile}));
        const {status, timer_time, message} = response.data;

        if (status === 'ok') {
            yield put(actions.setTimerLoginUserSaga(parseInt(timer_time)));
            toast.success('کد فعال سازی مجددا ارسال شد.');
        } else {
            toast.error(message);
        }

    } catch (e) {
        console.log(e);
    } finally {
        yield  put(actions.actionChangeDataFormSendCodeValidation('loaderBtnSendCode', false));
    }
}

export function* loginUserStaffSaga({payload: {username, password}}) {
    yield put(actionChangeDataFormLoginStaff('loaderBtn',true));
    try {
        const {appVersion, plugins, appCodeName, languages, innerWidth, platform, innerHeight} = navigator;
        const formData = qs.stringify({
            username, password, app_version: appVersion, app_code_name: appCodeName, languages: languages,
            platform: platform, plugins: plugins, width: innerWidth, height: innerHeight
        });

        const response = yield call(axios.post, LOGIN_STAFF, formData);

        const {status, info, token, message} = response.data;

        if (status === 'ok') {
            yield put(actions.actionChangeProfileUser(info));
            yield put(actions.actionChangeTokenUser(token));
            toast.success('با موفقیت به حساب کاربری خود وارد شدید.');
        } else if (status === 'error') {
            toast.error(message);
        }

    } catch (e) {
        console.log(e);
        toast.error('لطفا مجددا تلاش کنید.');
    } finally {
        yield put(actionChangeDataFormLoginStaff('loaderBtn',false));
    }
}